import React, {useEffect, useState} from "react";
import {css, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {mt} from "@pg-design/helpers-css";
import {BrandArrowRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {OfferBoxBase} from "../../../atoms/OfferBoxBase";

interface INextPageBox {
    nextPageLink: string;
    elementsToVisit: {
        amount: number;
        name: string;
    };
    /*
     * We are using this component on the listing view, and sometimes there is a situation when this component is rendered
     * alone in a separate row. When such situation occurs component is not able to set the right height - same as other list elements.
     * In order to set the same height as other list elements we need a reference to e.g. first list element.
     * Basing on this reference we are able to read and set the right height of this component.
     */
    referenceElementId?: string;
}

export const NextPageBox = (props: INextPageBox) => {
    const {nextPageLink, elementsToVisit} = props;
    const theme = useTheme();

    const [minHeight, setMinHeight] = useState(0);

    useEffect(() => {
        if (props.referenceElementId) {
            const firstListElement = document.getElementById(props.referenceElementId);
            if (firstListElement && !minHeight) {
                setMinHeight(firstListElement.offsetHeight);
            }
        }
    }, [props.referenceElementId]);

    return (
        <NextPageBoxBase as="a" href={nextPageLink} style={{minHeight}}>
            <div css={arrowWrap}>
                <BrandArrowRightIcon size="7.6" wrapperSize="11.2" wrapperColor={theme.colors.primary} wrapperType="circle" />
            </div>
            <Text as="div" variant="headline_4" align="center">
                Przejdź do
                <br /> następnej strony
            </Text>
            <Text css={mt(4)} variant="body_copy_2" align="center">
                Zobacz jeszcze{" "}
                <span css={weight}>
                    {elementsToVisit.amount} {elementsToVisit.name}
                </span>
            </Text>
        </NextPageBoxBase>
    );
};

/**
 * Styles and elements
 */
const NextPageBoxBase = styled(OfferBoxBase)<{href?: string}>`
    height: 100%;
    padding: 1.5rem 1.5rem;
    cursor: pointer;
    justify-content: center;
    align-items: center;

    &:hover,
    &:focus {
        color: inherit;
        text-decoration: none;
    }
`;

const arrowWrap = css`
    padding: 0 0 2.4rem;
    display: flex;
    justify-content: center;
`;

const weight = css`
    font-weight: 700;
`;
import React, {useEffect, useState} from "react";
import {css, useTheme} from "@emotion/react";
import styled from "@emotion/styled";

import {mt} from "@pg-design/helpers-css";
import {BrandArrowRightIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {OfferBoxBase} from "../../../atoms/OfferBoxBase";

interface INextPageBox {
    nextPageLink: string;
    elementsToVisit: {
        amount: number;
        name: string;
    };
    /*
     * We are using this component on the listing view, and sometimes there is a situation when this component is rendered
     * alone in a separate row. When such situation occurs component is not able to set the right height - same as other list elements.
     * In order to set the same height as other list elements we need a reference to e.g. first list element.
     * Basing on this reference we are able to read and set the right height of this component.
     */
    referenceElementId?: string;
}

export const NextPageBox = (props: INextPageBox) => {
    const {nextPageLink, elementsToVisit} = props;
    const theme = useTheme();

    const [minHeight, setMinHeight] = useState(0);

    useEffect(() => {
        if (props.referenceElementId) {
            const firstListElement = document.getElementById(props.referenceElementId);
            if (firstListElement && !minHeight) {
                setMinHeight(firstListElement.offsetHeight);
            }
        }
    }, [props.referenceElementId]);

    return (
        <NextPageBoxBase as="a" href={nextPageLink} style={{minHeight}}>
            <div css={arrowWrap}>
                <BrandArrowRightIcon size="7.6" wrapperSize="11.2" wrapperColor={theme.colors.primary} wrapperType="circle" />
            </div>
            <Text as="div" variant="headline_4" align="center">
                Przejdź do
                <br /> następnej strony
            </Text>
            <Text css={mt(4)} variant="body_copy_2" align="center">
                Zobacz jeszcze{" "}
                <span css={weight}>
                    {elementsToVisit.amount} {elementsToVisit.name}
                </span>
            </Text>
        </NextPageBoxBase>
    );
};

/**
 * Styles and elements
 */
const NextPageBoxBase = styled(OfferBoxBase)<{href?: string}>`
    height: 100%;
    padding: 1.5rem 1.5rem;
    cursor: pointer;
    justify-content: center;
    align-items: center;

    &:hover,
    &:focus {
        color: inherit;
        text-decoration: none;
    }
`;

const arrowWrap = css`
    padding: 0 0 2.4rem;
    display: flex;
    justify-content: center;
`;

const weight = css`
    font-weight: 700;
`;
